var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDustbin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.347,
    height: 14.032,
    viewBox: "0 0 11.347 14.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-button-svgrepo-com",
    transform: "translate(-46.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38288",
    "data-name": "Group 38288",
    transform: "translate(46.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65259",
    "data-name": "Path 65259",
    d: "M55.9,1.681H53.715a1.9,1.9,0,0,0-3.773,0H47.758a1.6,1.6,0,0,0-1.6,1.6v.082a1.6,1.6,0,0,0,1.013,1.489v7.573a1.6,1.6,0,0,0,1.6,1.6h6.115a1.6,1.6,0,0,0,1.6-1.6V4.856A1.6,1.6,0,0,0,57.5,3.367V3.284A1.6,1.6,0,0,0,55.9,1.681ZM51.828.76a1.141,1.141,0,0,1,1.118.921H50.711A1.141,1.141,0,0,1,51.828.76Zm3.9,11.668a.844.844,0,0,1-.843.843H48.771a.844.844,0,0,1-.843-.843V4.97h7.8Zm1.013-9.062a.844.844,0,0,1-.843.843H47.758a.844.844,0,0,1-.843-.843V3.284a.844.844,0,0,1,.843-.843H55.9a.844.844,0,0,1,.843.843v.082Z",
    transform: "translate(-46.155 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65260",
    "data-name": "Path 65260",
    d: "M158.455,254.611a.38.38,0,0,0,.38-.38v-4.28a.38.38,0,1,0-.76,0v4.28A.38.38,0,0,0,158.455,254.611Z",
    transform: "translate(-154.82 -242.312)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65261",
    "data-name": "Path 65261",
    d: "M228.525,254.611a.38.38,0,0,0,.38-.38v-4.28a.38.38,0,1,0-.76,0v4.28A.38.38,0,0,0,228.525,254.611Z",
    transform: "translate(-222.852 -242.312)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65262",
    "data-name": "Path 65262",
    d: "M298.594,254.611a.38.38,0,0,0,.38-.38v-4.28a.38.38,0,1,0-.76,0v4.28A.38.38,0,0,0,298.594,254.611Z",
    transform: "translate(-290.883 -242.312)",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustbin);
export default __webpack_public_path__ + "static/media/dustbin.deabd9d8c4ba1794042268e0d494968c.svg";
export { ForwardRef as ReactComponent };